import React from "react";
import { RouteProps } from "react-router-dom";
import { DashboardIcon } from "../../components/Icons/DashboardIcon";
import { HistoryIcon } from "../../components/Icons/HistoryIcon";
import { HrAssistantIcon } from "../../components/Icons/HrAssistantIcon";
import { DeviceIcon } from "../../components/Icons/DeviceIcon";
import { SettingIcon } from "../../components/Icons/SettingIcon";
import { StaffIcon } from "../../components/Icons/StaffIcon";
import { TimesheetIcon } from "../../components/Icons/TimesheetIcon";
import { TimesheetSubIcon } from "../../components/Icons/TimesheetSubIcon";
import { APP_ROUTES } from "../../constants/module";
import HrAssistant from "../../containers/HrAssistant";
import Dashboard from "../../containers/Dashboard";
import Devices from "../../containers/Devices";
import ProfilePage from "../../containers/Profile";
import Setting from "../../containers/Setting";
import Staff from "../../containers/Staff";
import StaffDetail from "../../containers/Staff/StaffDetail";
import StaffModal from "../../containers/Staff/StaffModal";
import Teams from "../../containers/Teams";
import Timesheet from "../../containers/Timesheet";
import TimesheetHistory from "../../containers/TimesheetHistory";

export const DEFAULT_COLOR = "#525560";
export const ACTIVE_COLOR = "#FFFFFF";
export const DEFAULT_SIZE: [number, number] = [38, 38];

export type ModuleItem = {
  title: string;
  label: string;
  defaultIcon: React.ReactElement;
  activeIcon: React.ReactElement;
  path: string;
  subRoutes?: Array<ModuleItem>;
  enabled: boolean;
};

const moduleList: ModuleItem[] = [
  {
    title: "nav.dashboard",
    label: "nav.dashboard",
    defaultIcon: (
      <DashboardIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    activeIcon: (
      <DashboardIcon
        color={ACTIVE_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    path: APP_ROUTES.DASHBOARD,
    enabled: true,
  },
  {
    title: "nav.personnel",
    label: "nav.personnel",
    defaultIcon: (
      <StaffIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    activeIcon: (
      <StaffIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    path: APP_ROUTES.STAFF,
    enabled: true,
    subRoutes: [
      {
        title: "nav.employees",
        label: "nav.employees",
        defaultIcon: (
          <StaffIcon
            color={DEFAULT_COLOR}
            size={[20, 20]}
            viewBox={DEFAULT_SIZE}
          />
        ),
        activeIcon: (
          <StaffIcon
            color={ACTIVE_COLOR}
            size={[20, 20]}
            viewBox={DEFAULT_SIZE}
          />
        ),
        path: APP_ROUTES.STAFF,
        enabled: true,
      },
      {
        title: "nav.teams",
        label: "nav.teams",
        defaultIcon: (
          <StaffIcon
            color={DEFAULT_COLOR}
            size={[20, 20]}
            viewBox={DEFAULT_SIZE}
          />
        ),
        activeIcon: (
          <StaffIcon
            color={ACTIVE_COLOR}
            size={[20, 20]}
            viewBox={DEFAULT_SIZE}
          />
        ),
        path: APP_ROUTES.TEAMS,
        enabled: true,
      },
    ],
  },
  {
    title: "nav.timesheet",
    label: "nav.timesheet",
    defaultIcon: (
      <TimesheetIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    activeIcon: (
      <TimesheetIcon
        color={ACTIVE_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    path: APP_ROUTES.TIMESHEET,
    enabled: true,
    subRoutes: [
      {
        title: "nav.history",
        label: "nav.history",
        defaultIcon: (
          <HistoryIcon
            color={DEFAULT_COLOR}
            size={[20, 20]}
            viewBox={[20, 20]}
          />
        ),
        activeIcon: (
          <HistoryIcon
            color={ACTIVE_COLOR}
            size={[20, 20]}
            viewBox={[20, 20]}
          />
        ),
        path: APP_ROUTES.TIMESHEET,
        enabled: true,
      },
      {
        title: "nav.timesheetSub",
        label: "nav.timesheetSub",
        defaultIcon: (
          <TimesheetSubIcon
            color={DEFAULT_COLOR}
            size={[20, 20]}
            viewBox={[20, 20]}
          />
        ),
        activeIcon: (
          <TimesheetSubIcon
            color={ACTIVE_COLOR}
            size={[20, 20]}
            viewBox={[20, 20]}
          />
        ),
        path: APP_ROUTES.TIMESHEET_TIMEKEEPING,
        enabled: true,
      },
    ],
  },
  {
    title: "nav.hrAssistant",
    label: "nav.hrAssistant",
    defaultIcon: (
      <HrAssistantIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={[24, 24]}
      />
    ),
    activeIcon: (
      <HrAssistantIcon
        color={ACTIVE_COLOR}
        size={DEFAULT_SIZE}
        viewBox={[24, 24]}
      />
    ),
    path: APP_ROUTES.HR_ASSISTANT,
    enabled: true,
  },
  {
    title: "nav.devices",
    label: "nav.devices",
    defaultIcon: (
      <DeviceIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    activeIcon: (
      <DeviceIcon
        color={ACTIVE_COLOR}
        size={DEFAULT_SIZE}
        viewBox={DEFAULT_SIZE}
      />
    ),
    path: APP_ROUTES.DEVICES,
    enabled: true,
  },
  {
    title: "nav.setting",
    label: "nav.setting",
    defaultIcon: (
      <SettingIcon
        color={DEFAULT_COLOR}
        size={DEFAULT_SIZE}
        viewBox={[23, 23]}
      />
    ),
    activeIcon: (
      <SettingIcon
        color={ACTIVE_COLOR}
        size={DEFAULT_SIZE}
        viewBox={[23, 23]}
      />
    ),
    path: APP_ROUTES.SETTING,
    enabled: true,
  },
];

export const appRoutes: Array<RouteProps> = [
  {
    exact: true,
    path: APP_ROUTES.DASHBOARD,
    component: Dashboard,
  },
  {
    exact: true,
    path: APP_ROUTES.PROFILE,
    component: ProfilePage,
  },
  {
    exact: true,
    path: APP_ROUTES.STAFF,
    component: Staff,
  },
  {
    exact: true,
    path: APP_ROUTES.TEAMS,
    component: Teams,
  },
  {
    exact: true,
    path: APP_ROUTES.STAFF_DETAIL,
    component: StaffDetail,
  },
  {
    exact: true,
    path: APP_ROUTES.STAFF_CREATE,
    component: StaffModal,
  },
  {
    exact: true,
    path: APP_ROUTES.STAFF_EDIT,
    component: StaffModal,
  },
  {
    exact: true,
    path: APP_ROUTES.TIMESHEET_TIMEKEEPING,
    component: Timesheet,
  },
  {
    exact: true,
    path: APP_ROUTES.TIMESHEET,
    component: TimesheetHistory,
  },
  {
    exact: true,
    path: APP_ROUTES.HR_ASSISTANT,
    component: HrAssistant,
  },
  {
    exact: true,
    path: APP_ROUTES.DEVICES,
    component: Devices,
  },
  {
    exact: true,
    path: APP_ROUTES.SETTING,
    component: Setting,
  },
];

export default moduleList;
